import { getCompanyInitialStoreState } from '@/store/modules/company/helper';

import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state: getCompanyInitialStoreState(),
  getters,
  actions,
  mutations,
}
